import { render, staticRenderFns } from "./SalonMasterAdminPartsItem.vue?vue&type=template&id=b4006848&scoped=true"
import script from "./SalonMasterAdminPartsItem.vue?vue&type=script&lang=js"
export * from "./SalonMasterAdminPartsItem.vue?vue&type=script&lang=js"
import style0 from "./SalonMasterAdminPartsItem.vue?vue&type=style&index=0&id=b4006848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4006848",
  null
  
)

export default component.exports